import React, { useEffect, useRef, useState } from "react";
import "./button.css";
import { MdAdd } from "react-icons/md";
import { IoArrowBack } from "react-icons/io5";
import { AiOutlineDown } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export const AddButton =  React.memo(({ back, onClick, title = "ADD" }) => {
  return (
    <div className={`btn btn-success`} role="button" onClick={onClick}>
      <MdAdd className="btn-icon" size={20} color="#fff" />
      {title?.toUpperCase()}
    </div>
  );
});

export const BackButton =  React.memo(({ onClick }) => {
  const navigate = useNavigate();
  return (
    <div className={`btn btn-info`} role="button" onClick={() => navigate(-1)}>
      <IoArrowBack className="btn-icon" size={20} color="#fff" />
      BACK
    </div>
  );
});

export const SaveButton =  React.memo(({ onClick, class1 = "", disable,title }) => {
  return (
    <div
      className={`btn btn-save ${class1}`}
      style={{
        cursor: disable && "default",
        backgroundColor: disable ? "gray" : "",
        border: disable ? "none" : "",
      }}
      role="button"
      onClick={() => {
        if (!disable) {
          onClick();
        }
      }}
    >
     {title?title?.toUpperCase(): "SAVE"} 
    </div>
  );
});
export const Button =  React.memo(({ title, icon, mt, onClick, bgColor,disabled=false, ...props }) => {
  return (
    <div
      className={`btn btn-success`}
      style={{ marginTop: mt, backgroundColor: disabled? "" :bgColor, borderColor:  disabled? "" :bgColor,
        //  cursor:disabled?"not-allowed":"pointer"
         }}
      role="button"
      onClick={()=>{
        onClick()
        // if(!disabled){
        //   onClick()
        // }
      }}
      {...props}
    >
      {icon}
      {title}
    </div>
  );
});
export const SubmitButton =  React.memo(({ title, icon, mt, onClick }) => {
  return (
    <div
      className="submit-btn"
      style={{ marginTop: mt }}
      role="button"
      onClick={onClick}
    >
      {icon}
      {title}
    </div>
  );
});

export const HelpButton =  React.memo(({ link, Hindi = true }) => {
  const [HelpClick, setHelpClick] = useState(false);
  const helpRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setHelpClick(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div className="Help" ref={helpRef}>
      <button className="RP-help" onClick={() => setHelpClick(!HelpClick)}>
        <pre>
          HELP{" "}
          <AiOutlineDown style={{ fontSize: "12px", fontWeight: "1000" }} />
        </pre>{" "}
        {/* <option hidden></option> */}
      </button>
      {HelpClick && (
        <div className="Help-content">
          <a className="help-content-item" href={link[0]} target="_blank">
            English
          </a>
          {Hindi && (
            <a className="help-content-item" href={link[1]} target="_blank">
              Hindi
            </a>
          )}
        </div>
      )}
    </div>
  );
});

export const EditButton =  React.memo(({ onClick,bg }) => {
  return (
    <div  onClick={onClick} className="edit-btn">
      <FiEdit size={20} marbo color={bg} />
    </div>
  );
});

export const DownloadButton =  React.memo(({excelDown,PDFDown,side = "center",pl="0px",mt='0px'})=>{

  return(
    <div
    className="epss-btn"
    style={{
      paddingLeft:pl,
      justifyContent:side,
      alignItems: "center",
      marginTop:mt,
      marginRight: "10px",
    }}
  >
    {excelDown && (
      <button
        style={{
          padding: "0.5em 1em",
          fontSize: ".88em",
          backgroundColor: "#e9e9e9",
        }}
        onClick={excelDown}
      >
        Excel
      </button>
    )}

    {PDFDown && (
      <button
        style={{
          padding: "0.5em 1em",
          fontSize: ".88em",
          backgroundColor: "#e9e9e9",
        }}
        onClick={PDFDown}
      >
        PDF
      </button>
    )}
  </div>
  )

})

